// Client-side writer for the grass-ID ground-truth labeling pipeline
// (PATCH /api/user/analysis/[id] → user_verified_grass_type /
// verification_source / verified_at). Shared by the picker-correction path
// and the confirm tile so the two call sites can't drift.
//
// Fire-and-forget by design: labeling must never block or break the result
// UX. Web deliberately sends NO X-Device-Id header — on the analyze route
// that header's presence is what classifies an anonymous request as mobile
// for quota purposes, so web anon ownership rests on IP hash + the server's
// 7-day hash-less write window instead.

export type VerificationSource = 'confirmed' | 'corrected' | 'picker_fallback'

/**
 * Resolves true only when the server acknowledged the write (2xx) — callers
 * that report labeling telemetry must await this instead of assuming success
 * (anon rows can legitimately 404: not the creator, stale, already terminal).
 * Never rejects.
 */
export function verifyAnalysis(
  analysisId: string,
  verifiedGrassType: string,
  source: VerificationSource,
): Promise<boolean> {
  return fetch(`/api/user/analysis/${analysisId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ verifiedGrassType, source }),
  })
    .then((res) => res.ok)
    .catch(() => false)
}
